module.exports = __webpack_public_path__ + "img/2_276.cf61fa41.png";